var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pb-15"},[(
      _vm.SERVER_RESPONSES_ENUM.WAITING_RESPONSE == _vm.user_profile.response_status
    )?_c('wait-server-progress'):(
      _vm.SERVER_RESPONSES_ENUM.RESPONSE_OK == _vm.user_profile.response_status
    )?_c('div',[_c('user-connected-main-page-container')],1):_c('sign-in-or-log-in')],1)}
var staticRenderFns = []

export { render, staticRenderFns }